import BaseApi from "../base";

export default class Notification extends BaseApi {

}

